import { CircularProgress } from '@material-ui/core';
import { Box } from '@material-ui/core';
import { CustomTaskDialog } from '@roc/feature-general-tasks';
import { StandardDialog } from '@roc/ui';
import { observer } from 'mobx-react';
import { useEffect } from 'react';
import { useDocumentStore } from '../../../hooks/useDocumentStore';
import { ValuationDisputeForm } from './valuationDisputeForm';
import { Document } from '@roc/feature-types';

export type ValuationDisputeDialogProps = {
  open: boolean;
  onClose: () => void;
  document?: Document;
};

export const ValuationDisputeDialog = observer((props: ValuationDisputeDialogProps) => {
  const { document, open, onClose } = props;

  const taskId = document?.taskId;
  const loanId = document?.loanId;
  const propertyId = document?.collateralId;
  const taskName = document?.title ?? document?.taskName ?? '';

  const {
    documentStore: {
      documentFormStore: { valuationDisputeStore },
    },
  } = useDocumentStore();

  useEffect(() => {
    if (open) {
      valuationDisputeStore.initialize(loanId, propertyId, taskName, document?.collateralAddress);
    } else {
      valuationDisputeStore.reset();
    }
  }, [open, taskId, loanId, propertyId, taskName]);

  const content = valuationDisputeStore.isLoading ? (
    <Box display="flex" justifyContent="center" alignItems="center" minHeight={200}>
      <CircularProgress />
    </Box>
  ) : (
    <ValuationDisputeForm
      store={valuationDisputeStore}
      taskId={taskId}
      loanId={loanId}
      propertyId={propertyId}
      taskName={taskName}
      onClose={onClose}
    />
  );

  return taskId ? (
    <CustomTaskDialog
      open={open}
      title="Valuation Dispute"
      maxWidth="lg"
      handleClose={onClose}
      dialogContent={content}
      taskId={taskId}
    />
  ) : (
    <StandardDialog
      open={open}
      title="Valuation Dispute"
      maxWidth="lg"
      handleClose={onClose}
      dialogContent={content}
    />
  );
});
